"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback } from "react";
const MAX_PINNED_WAVES = 10;
const STORAGE_KEY = "pinnedWave";
export function usePinnedWaves() {
  const $ = _c(10);
  const [pinnedIds, setPinnedIds] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = id => {
      setPinnedIds(prev => {
        const newIds = [id, ...prev.filter(pinnedId => pinnedId !== id)];
        return newIds.slice(0, MAX_PINNED_WAVES);
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const addId = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = id_0 => {
      setPinnedIds(prev_0 => prev_0.filter(pinnedId_0 => pinnedId_0 !== id_0));
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const removeId = t1;
  let t2;
  if ($[2] !== pinnedIds) {
    t2 = () => pinnedIds;
    $[2] = pinnedIds;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getAllIds = t2;
  let t3;
  let t4;
  if ($[4] !== pinnedIds) {
    t3 = () => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(pinnedIds));
    };
    t4 = [pinnedIds];
    $[4] = pinnedIds;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== getAllIds || $[8] !== pinnedIds) {
    t5 = {
      pinnedIds,
      addId,
      removeId,
      getAllIds
    };
    $[7] = getAllIds;
    $[8] = pinnedIds;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp() {
  if (typeof window !== "undefined") {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  }
  return [];
}